import Environment from '../services/Environment';

const { store } = Environment;
const allImages = {};

if (store === 'bump') {
  import('./bump').then((res) => {
    Object.assign(allImages, res.default);
  });
}

if (store === 'bitsy') {
  import('./bitsy').then((res) => {
    Object.assign(allImages, res.default);
  });
}

if (store === 'wtebump') {
  import('./wtebump').then((res) => {
    Object.assign(allImages, res.default);
  });
}

if (store === 'pnmbump') {
  import('./pnmbump').then((res) => {
    Object.assign(allImages, res.default);
  });
}

const commonImages = {
  dueDateCalculator: {
    src: require('./due-date-calc/due-date-christine.png'),
    alt: 'CEO Christine holding a Bump Box while pregnant',
  },
  yourBabyReport: {
    src: require('./due-date-calc/your-baby-report.png'),
    alt: 'Letter tiles spelling out We Are Having a Baby',
  },
  bumpBoxImg: require('./bump/logos/bumpLogo.png'),
  bitsyGray: require('./nav-images/bitsyLogoGray.png'),
  bbLogo: require('./nav-images/bumpBoxLogo.png'),
  aboutHero: require('./about-us/aboutHero.png'),
  aboutHeroMobile: require('./about-us/aboutHeroMobile.png'),
  bumpFundHero: require('./bump-fund/bumpFundHero.png'),
  bumpFundHeroMobile: require('./bump-fund/bumpFundHeroMobile.png'),
  registryHero: require('./registry/BumpBoxes_Web_Registry_Webslider_Desktop.png'),
  registryHeroMobile: require('./registry/BumpBoxes_Web_Registry_Webslider_Mobile.png'),
  registryBox: require('./registry/BumpBoxes_Registry_ClosedBox.png'),
  seenBump: {
    src: require('./bump/as-seen-in/thebump.png'),
    webp: require('./bump/as-seen-in/thebump.png'),
  },
  seenBuzzfeed: {
    src: require('./bump/as-seen-in/buzzfeed.png'),
    webp: require('./bump/as-seen-in/buzzfeed.png'),
  },
  seenInStyle: {
    src: require('./bump/as-seen-in/instyle.png'),
    webp: require('./bump/as-seen-in/instyle.png'),
  },
  seenScarymommy: {
    src: require('./bump/as-seen-in/scarymommy.png'),
    webp: require('./bump/as-seen-in/scarymommy.png'),
  },
  seenPregnancyandnewborn: {
    src: require('./bump/as-seen-in/pregnancyandnewborn.png'),
    webp: require('./bump/as-seen-in/pregnancyandnewborn.png'),
  },
  seenWhattoexpect: {
    src: require('./bump/as-seen-in/whattoexpect.png'),
    webp: require('./bump/as-seen-in/whattoexpect.png'),
  },
  seenProjectNursery: {
    src: require('./bump/as-seen-in/projectnursery.png'),
    webp: require('./bump/as-seen-in/projectnursery.png'),
  },
  team: {
    teamHero: require('./team/team-hero.png'),
    teamHeroMobile: require('./team/team-hero-mobile.png'),
    members: [
      {
        name: 'Abby',
        src: require('./team/Abby.png'),
      },
      {
        name: 'Amy',
        src: require('./team/Amy.png'),
      },
      {
        name: 'Billie',
        src: require('./team/Billie.png'),
      },
      {
        name: 'Bree',
        src: require('./team/Bree.png'),
      },
      {
        name: 'Bret',
        src: require('./team/Bret.png'),
      },
      {
        name: 'Brianna',
        src: require('./team/Brianna.png'),
      },
      {
        name: 'Carlos',
        src: require('./team/Carlos.png'),
      },
      {
        name: 'Cat',
        src: require('./team/Cat.png'),
      },
      {
        name: 'Christine',
        src: require('./team/Christine.png'),
      },
      {
        name: 'Connor',
        src: require('./team/Connor.png'),
      },
      {
        name: 'Cory',
        src: require('./team/Cory.png'),
      },
      {
        name: 'Emily',
        src: require('./team/Emily.png'),
      },
      {
        name: 'Emily P',
        src: require('./team/Emily-Pitzer.png'),
      },
      {
        name: 'Erika',
        src: require('./team/Erika.png'),
      },
      {
        name: 'Fred',
        src: require('./team/Fred.png'),
      },
      {
        name: 'Jason',
        src: require('./team/Jason.png'),
      },
      {
        name: 'Karyn',
        src: require('./team/Karyn.png'),
      },
      {
        name: 'Kevin',
        src: require('./team/Kevin.png'),
      },
      {
        name: 'Leland',
        src: require('./team/Leland.png'),
      },
      {
        name: 'Lisa',
        src: require('./team/Lisa-Papada.png'),
      },
      {
        name: 'Megan',
        src: require('./team/Megan.png'),
      },
      {
        name: 'Melissa',
        src: require('./team/Melissa.png'),
      },
      {
        name: 'Paul',
        src: require('./team/Paul.png'),
      },
      {
        name: 'Rachel',
        src: require('./team/Rachel.png'),
      },
      {
        name: 'Sarah G',
        src: require('./team/Sarah-Gruber.png'),
      },
      {
        name: 'Sarah H',
        src: require('./team/Sarah-Hayes.png'),
      },
      {
        name: 'Sarah R',
        src: require('./team/Sarah-Roberts.png'),
      },
    ],
  },
  careersHero: require('./careers/careers-hero.png'),
  careersHeroMobile: require('./careers/careers-hero-mobile.png'),
  pressHero: require('./press/press-hero.png'),
  pressHeroMobile: require('./press/press-hero-mobile.png'),
  giveawayModalImage: require('./bump/giveaway/giveaway-modal.jpg'),
  referralSharingModalImage: require('./referral-sharing/referral-sharing-popup.jpg'),
  lifeInsuranceHero: require('./life-insurance/life-insurance-hero.jpg'),
  extensionsHero: require('./extensions/extensions-hero.jpg'),
  prenatalVitamins: {
    prenatalVitaminsBanner: require('./prenatal-vitamins/prenatalLandingPageBanner.jpg'),
    prenatalVitaminsBanner2: require('./prenatal-vitamins/prenatalLandingPageBanner2.jpg'),
    metaImage: {
      src: require('./prenatal-vitamins/prenatalLandingPageWebsliderMobile.png'),
    },
    bottleImage: {
      src: require('./prenatal-vitamins/prenatalFrontBottle.png'),
    },
    howItWorks: [
      {
        src: require('./prenatal-vitamins/prenatalLandingPageHowItWorksStep1.png'),
        alt:
          'Prenatal Vitamins How It Works Step 1 - dark pink cell phone icon on top of lighter pink circle',
        text: 'Order your free \n prenatal vitamins.',
      },
      {
        src: require('./prenatal-vitamins/prenatalLandingPageHowItWorksStep2.png'),
        alt:
          'Prenatal Vitamins How It Works Step 2 - pink package icon on top of lighter pink circle.',
        text: 'Get prenatals shipped \n to your door.',
      },
      {
        src: require('./prenatal-vitamins/prenatalLandingPageHowItWorksStep3.png'),
        alt:
          'Prenatal Vitamins How It Works Step 3 - vitamin icon on stop of pink circle.',
        text: 'Stay \n nourished.',
      },
    ],
    testimonials: [
      {
        src: require('./prenatal-vitamins/prenatalLandingPageTestimonial1.png'),
        alt: 'Testimonial 1 - vitamin bottle spilling onto pink satan.',
        text: `"Please do something incredible for your holistic well-being and purchase these vitamins.
        They have impacted me so positively, and I look forward to continue staying a Bump Boxes supporter
         for many years to come."`,
      },
      {
        src: require('./prenatal-vitamins/prenatalLandingPageTestimonial2.png'),
        alt:
          'Testimonial 2 - vitamin bottle spill onto pick square with white flowers around it.',
        text: `"Yes to health and wellness! I've been looking for a great multi for many years,
        and I have finally found one that can grow with me throughout all stages in my life."`,
      },
      {
        src: require('./prenatal-vitamins/prenatalLandingPageTestimonial3.png'),
        alt:
          'Testimonial 3 - hand holding a prenatal vitams bottle in front of pink background',
        text: `"I appreciate knowing more about where my vitamins are sourced and why.
        I appreciate the choices about how and where to source the ingredients are evidence-based.
        Their customer service is the best!"`,
      },
    ],
  },
  bumpFund: {
    isBumpFundForYou: [
      {
        src: require('./bump-fund/BumpFund_Icons_01.svg'),
        alt: 'Light pink icon with bar graph with an upward trend.',
        text:
          'Simple revenue models\u{2014}transactions, subscription, or affiliate.',
      },
      {
        src: require('./bump-fund/BumpFund_Icons_02.svg'),
        alt:
          'Light pink icon with computer screen with paper and pencil on it.',
        text:
          'Functional Prototype *before* investing (or previous product success).',
      },
      {
        src: require('./bump-fund/BumpFund_Icons_03.svg'),
        alt: 'Light pink icon with line graph with an upward trend.',
        text:
          'Small but measurable usage\u{2014}some customers, early revenue.',
      },
      {
        src: require('./bump-fund/BumpFund_Icons_04.svg'),
        alt: 'Light pink icon with light bulb and gear.',
        text: 'Product solves a problem for a specific target customer.',
      },
      {
        src: require('./bump-fund/BumpFund_Icons_05.svg'),
        alt:
          'Light pink icon with awning and a money sign inside of circular arrows.',
        text:
          'Capital-efficient businesses\u{2014}can be operational at <$1Million funding.',
      },
      {
        src: require('./bump-fund/BumpFund_Icons_06.svg'),
        alt: 'Light pink icon with internet connectivity image.',
        text:
          'Primarily internet-based distribution\u{2014}search, social, mobile, local.',
      },
    ],
  },
  cancellationOffer: {
    src: require('./cancellation-flow/cancellation-offer-modal.jpg'),
    webp: require('./cancellation-flow/cancellation-offer-modal.webp'),
    alt: 'Mom and baby sitting with their Bitsy box',
  },
};

Object.assign(allImages, commonImages);

export default allImages;
